export const path = [
  { name: "Home", url: "/" },
  { name: "Products", url: "/products" },
  { name: "About", url: "/about" },
  { name: "Signin", url: "/signin" },
];

export const pathapp = {
  home: "/",
  about: "/about",
  products: `/products/`,
  productId: `/products/:id`,
  signin: "/signin",
  cart: "/cart",
  signup: "/signup",
  delivery: "/delivery",
  checkout: "/checkout",
  checkout_success: "/checkout/success",
  admin: "/admin",
  dashboard: "/dashboard",
  adminproduct: "/adminproduct",
  adminuser: "/adminuser",
};
